import {
	ADD_TO_ENGAGEMENT_COMMENT_SLICE,
	CLEAR_COMMENTS,
	CLEAR_ENGAGEMENT_COMMENTS,
	CREATE_ENGAGEMENT_COMMENT,
	CREATE_ENGAGEMENT_COMMENT_REPLY,
	DELETE_ENGAGEMENT_COMMENT_CHILD,
	DELETE_ENGAGEMENT_COMMENT_PARENT,
	DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL,
	GET_ALL_ENGAGEMENT_COMMENTS,
	REMOVE_ENGAGEMENT_COMMENTS_FILTER,
	SET_ENGAGEMENT_COMMENTS_CONFIG_DATA,
	SET_ENGAGEMENT_COMMENTS_FILTER,
	SET_SELECTED_ENGAGEMENT_COMMENT_GUID,
	TOGGLE_INLINE_COMMENTS_EDITOR,
	UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS,
	UPDATE_ENGAGEMENT_COMMENT,
	UPDATE_ENGAGEMENT_COMMENT_STATUS
} from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, documentTypes, EngagementCommentStatus} from '../../util/uiconstants';
import {GetAllEngagementCommentsUrl, GetAllFormCommentsUrl, PatchDeleteFormCommentsUrl, CreateFormCommentsUrl} from '../apiUrls';

export const getAllEngagementComments = (
	engagementId,
	parentEntityId,
	parentEntityUid,
	entityId,
	entityUid,
	showDeleted,
	isGuestUser,
	documentId,
	documentTypeId,
	args = {}
) => {
	const isFormCommentToBeCalled = isGuestUser || documentTypeId === documentTypes.independenceFormIndividual;
	const url = !isFormCommentToBeCalled
		? GetAllEngagementCommentsUrl(engagementId, {parentEntityId, parentEntityUid, entityId, entityUid, showDeleted})
		: GetAllFormCommentsUrl(engagementId, documentId, {
				parentEntityId,
				parentEntityUid,
				entityId,
				entityUid,
				showDeleted
			});

	return {
		type: GET_ALL_ENGAGEMENT_COMMENTS,
		args,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const addToEngagementCommentsSlice = (comment) => {
	return {
		type: ADD_TO_ENGAGEMENT_COMMENT_SLICE,
		comment: comment
	};
};

export const setEngagementCommentsConfig = (config) => {
	return {
		type: SET_ENGAGEMENT_COMMENTS_CONFIG_DATA,
		config: config
	};
};

export const displayEngagementCommentInputModal = (modalConfiguration, args = {}) => {
	return {
		type: DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL,
		modalConfig: modalConfiguration,
		args
	};
};

export const setEngagementCommentsFilter = (filter, args = {}) => {
	return {
		type: SET_ENGAGEMENT_COMMENTS_FILTER,
		filter: filter,
		args
	};
};

export const removeEngagementCommentsFilter = (filterType, args = {}) => {
	return {
		type: REMOVE_ENGAGEMENT_COMMENTS_FILTER,
		filterType: filterType,
		args
	};
};

export const setSelectedEngagementCommentGuid = (guid, args = {}) => {
	return {
		type: SET_SELECTED_ENGAGEMENT_COMMENT_GUID,
		guid: guid,
		args
	};
};

export const clearEngagementComments = (entityUid, args = {}) => {
	return {
		type: CLEAR_ENGAGEMENT_COMMENTS,
		entityUid: entityUid,
		args
	};
};

function createEngagementComment(engagementId, data, actionType, isGuest, documentId, documentTypeId, args = {}) {
	const isFormCommentToBeCalled = isGuest || documentTypeId === documentTypes.independenceFormIndividual;
	const url = !isFormCommentToBeCalled ? `${Env.getBaseURL(serviceURL, engagementId)}comments/` : CreateFormCommentsUrl(engagementId, documentId);
	return {
		type: actionType,
		args,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
}

function updateEngagementComment(engagementId, data, actionType, isGuest, documentId, documentTypeId, ignoreBodyUpdate, args = {}) {
	const isFormCommentToBeCalled = isGuest || documentTypeId === documentTypes.independenceFormIndividual;
	let baseUrl = `${Env.getBaseURL(serviceURL, engagementId)}comments/${data.engagementCommentId}`;
	ignoreBodyUpdate === true ? (baseUrl += '?ignoreBodyUpdate=true') : '';
	const url = !isFormCommentToBeCalled ? baseUrl : PatchDeleteFormCommentsUrl(engagementId, documentId, data.engagementCommentId);

	return {
		type: actionType,
		args,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
}

function deleteEngagementComment(
	engagementId,
	engagementCommentGuid,
	parentEngagementCommentGuid,
	actionType,
	engagementCommentId,
	entityUid,
	isGuestUser,
	documentId,
	documentTypeId,
	ignoreBodyUpdate,
	args = {}
) {
	const isFormCommentToBeCalled = isGuestUser || documentTypeId === documentTypes.independenceFormIndividual;
	let baseUrl = `${Env.getBaseURL(serviceURL, engagementId)}comments/${engagementCommentId}`;
	ignoreBodyUpdate === true ? (baseUrl += '?ignoreBodyUpdate=true') : '';
	const url = !isFormCommentToBeCalled ? baseUrl : PatchDeleteFormCommentsUrl(engagementId, documentId, engagementCommentId);

	return {
		type: actionType,
		args,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		parentEngagementCommentGuid: parentEngagementCommentGuid,
		engagementCommentGuid: engagementCommentGuid,
		entityUid: entityUid
	};
}

export function deleteEngagementCommentParent(
	engagementId,
	engagementCommentGuid,
	engagementCommentId,
	entityUid,
	isGuest,
	documentId,
	documentTypeId,
	ignoreBodyUpdate,
	args = {}
) {
	return deleteEngagementComment(
		engagementId,
		engagementCommentGuid,
		engagementCommentGuid,
		DELETE_ENGAGEMENT_COMMENT_PARENT,
		engagementCommentId,
		entityUid,
		isGuest,
		documentId,
		documentTypeId,
		ignoreBodyUpdate,
		args
	);
}

export function deleteEngagementCommentChild(
	engagementId,
	engagementCommentGuid,
	parentEngagementCommentGuid,
	engagementCommentId,
	entityUid,
	isGuestUser,
	documentId,
	documentTypeId,
	ignoreBodyUpdate,
	args = {}
) {
	return deleteEngagementComment(
		engagementId,
		engagementCommentGuid,
		parentEngagementCommentGuid,
		DELETE_ENGAGEMENT_COMMENT_CHILD,
		engagementCommentId,
		entityUid,
		isGuestUser,
		documentId,
		documentTypeId,
		ignoreBodyUpdate,
		args
	);
}

export function createEngagementCommentParent(engagementId, data, isGuest, documentId, documentTypeId, args = {}) {
	return createEngagementComment(engagementId, data, CREATE_ENGAGEMENT_COMMENT, isGuest, documentId, documentTypeId, args);
}

export function createEngagementCommentReply(engagementId, data, isGuest, documentId, documentTypeId, args = {}) {
	return createEngagementComment(engagementId, data, CREATE_ENGAGEMENT_COMMENT_REPLY, isGuest, documentId, documentTypeId, args);
}

export function updateEngagementCommentEntity(engagementId, data, isGuest, documentId, documentTypeId, ignoreBodyUpdate = true, args = {}) {
	return updateEngagementComment(engagementId, data, UPDATE_ENGAGEMENT_COMMENT, isGuest, documentId, documentTypeId, ignoreBodyUpdate, args);
}

export function updateEngagementCommentStatus(engagementId, data, isGuest, documentId, documentTypeId, ignoreBodyUpdate = true, args = {}) {
	return updateEngagementComment(engagementId, data, UPDATE_ENGAGEMENT_COMMENT_STATUS, isGuest, documentId, documentTypeId, ignoreBodyUpdate, args);
}

export function clearComments(engagementId, documentId, entityId, entityUId) {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}comments/-1`;

	const data = {
		entityId: entityId,
		entityUid: entityUId,
		documentId: documentId,
		updateAction: 1,
		engagementCommentStatusId: EngagementCommentStatus.cleared
	};

	return {
		type: CLEAR_COMMENTS,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
}

export const updateCommentCountAfterClearingComments = (bodyIds) => {
	return {
		type: UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS,
		bodyIds: bodyIds
	};
};

export const toggleInlineCommentsEditor = (toggle) => {
	return {
		type: TOGGLE_INLINE_COMMENTS_EDITOR,
		toggle: toggle
	};
};
